import { ElementFactory, PanelModel, Serializer } from "survey-core";

export class CtaPanelModel extends PanelModel {
  getType() {
    return "cta-panel";
  }

  public get index(): any {
    return this.getPropertyValue("index");
  }

  public set index(value: any) {
    this.setPropertyValue("index", value);
  }
}

export function registerCtaPanelSerializer() {
  Serializer.addClass(
    "cta-panel",
    [
      {
        name: "index",
        category: "general",
      },
    ],
    () => new CtaPanelModel(),
    "panel"
  );
}

export function registerCtaPanelElement() {
  ElementFactory.Instance.registerElement(
    "cta-panel",
    (name) => new CtaPanelModel(name)
  );
}
